var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"id":"btn-finish"},on:{"click":_vm.doFinish}},[_vm._v("おわる")])}
var staticRenderFns = []

export { render, staticRenderFns }